/*
 * Created by 九次方前端研发部-彭庆凯<pqk@jusfoun.com> on 07/02/2018.
*/

export  const dataZoom = [{
  show: true,
  height: 4,
  xAxisIndex: [0],
  left: '40',
  right: '40',
  bottom: "20",
  backgroundColor: '#002624',
  dataBackground: {
    areaStyle: {
      color: 'rgba(79, 140, 210, 0.4)'
    },
    lineStyle: {
      opacity: 0.8,
      color: '#8392A5'
    }
  },
  fillerColor: '#23A199',
  start: 0,
  end: 100,
  handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
  handleSize: '100%',
  handleStyle: {
    color: '#00ADFA',
    shadowBlur: 0,
    shadowColor: 'rgba(255, 0, 0, 1)',
    shadowOffsetX: 0,
    shadowOffsetY: 0
  },
  textStyle: {
    color: "#99ffcc",
    fontSize: '12'
  },
  borderColor: "#2cc0b6"
}, {
  type: "inside",
  show: true,
}]



// WEBPACK FOOTER //
// ./src/assets/js/common/echartsComm.js